import Layout from "../components/layout";
import Link from "next/link";
import { page_getStaticProps } from "../lib/statics";
import Seo from "../components/seo";
import React from "react";
import { ProductCard } from "../components/product-card";
import Image from "../components/image";
import { FeaturedOverview } from "../components/featured-overview";
import { FeaturedHero } from "../components/featured-hero";

const SelfContainedRatchetStraps = ({ categories, page }) => {
  const seo = {
    metaTitle: page?.attributes?.Title,
    metaDescription: page?.attributes?.Hero.hero,
  };

  return (
    <Layout categories={categories}>
      <Seo seo={seo} />

      <div className={`lg:py-16 lg:px-32 lg:bg-[#F5F5F5]`}>
        <div className="container mx-auto">
          <h2
            className={`font-display font-bold text-[40px] leading-none mb-8`}
          >
            {page?.attributes?.Title.toString().toUpperCase()}
          </h2>
          <FeaturedHero Hero={page?.attributes?.Hero} />
          <h2
            className={`font-display font-bold text-[40px] leading-none mt-16 pb-8 mb-8 border-b`}
          >
            OVERVIEW
          </h2>
          {page?.attributes?.overviews?.map((overview, key) => {
            return (
              <FeaturedOverview key={key} overview={overview} index={key} />
            );
          })}
          <h2
            className={`font-display font-bold text-[40px] leading-none mt-16 pb-8 mb-8 border-b`}
          >
            FEATURES
          </h2>
          <p className={`font-display font-bold text-[24px] my-4 leading-none`}>
            The wind up handle is only designed for two purposes:
          </p>
          <div className={`grid lg:grid-cols-3`}>
            <div className={`col-span-2`}>
              <p className={`font-display text-[18px]`}>
                1. To make sure the webbing doesn&lsquo;t unwind while the
                ratchet strap is in use.
                <br />
                2. To wind up the webbing when you have finished using the
                ratchet strap.
              </p>
              <p className={`font-display text-[18px] font-bold mt-4`}>
                The wind up mechanism will not carry any pressure.
              </p>
            </div>
            <div>
              <p className={`font-display text-[18px]`}>
                The Self Contained Ratchet must be used the same as any other
                ratchet. The user must always ratchet down their load as tight
                as possible before engaging the winding mechanism.
              </p>
            </div>
          </div>
          <div className={`grid lg:grid-cols-2 gap-8 mt-10`}>
            {page?.attributes?.Features?.positions?.map((position, key) => {
              return (
                <div key={key} className={`grid grid-cols-2 gap-8`}>
                  <div className="flex flex-col items-center justify-center min-h-[200px]">
                    <Image image={position.image} alt={position.text} />
                  </div>
                  <div>
                    <p
                      className={`font-display font-bold text-[24px] my-4 leading-none`}
                    >
                      POSITION {key + 1}:
                    </p>
                    <p className={`font-display text-[18px]`}>
                      {position.text}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
          <h2
            className={`font-display font-bold text-[40px] leading-none mt-16 pb-8 mb-8 border-b`}
          >
            PRODUCT VIDEO
          </h2>
          <div className="bg-white border flex flex-col items-center justify-center">
            <iframe
              width="100%"
              height="450px"
              src={page?.attributes?.video_url}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>

          {page?.attributes?.Products?.products?.data.length > 0 && (
            <div>
              <h2
                className={`font-display font-bold text-[40px] leading-none mt-16 pb-8 mb-8 border-b`}
              >
                PRODUCTS
              </h2>
              <section className={`grid grid-cols-3 gap-8 my-4`}>
                {page?.attributes?.Products?.products?.data.map(
                  (product, key) => {
                    return <ProductCard key={key} product={product} />;
                  }
                )}
              </section>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export async function getStaticProps() {
  return page_getStaticProps("self-contained-ratchet-straps-page");
}

export default SelfContainedRatchetStraps;
